import React from 'react'
import styled from 'styled-components'
import { Route, Switch } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Tab from './components/tab'
import ListGroup from 'estimate_list/components/list/list_group'
import Mguide from 'estimate_list/components/medium/mguide'
import Mreview from 'estimate_list/components/medium/mreview'
import Curation from 'estimate_list/components/curation'

const ListField = (props) => {
    const { domain, minishopInfo } = useSelector(state => state.initial)
    const host = domain === 'minishop' ? `/${minishopInfo?.mall_web_user}` : ''

    return (
        <>
            {(domain === 'shopping' || domain === 'pc') && <Tab />}
            <NavSpy id="nav_spy">
                <Switch>
                    <Route path={`${host}/list/:categoryID/curation/:idx_curation`} component={Curation} />
                    <Route path={`${host}/list/:categoryID/curation`} render={() => <Curation cateName={props.cateName} />} />
                    <Route path={`${host}/list/:categoryID/mreview/:idx_threads`} component={Mreview} />
                    <Route path={`${host}/list/:categoryID/mreview`} render={() => <Mreview cateName={props.cateName} />} />
                    <Route path={`${host}/list/:categoryID/mguide`} render={() => <Mguide cateName={props.cateName} />} />
                    <Route path={`${host}/list/:categoryID`} render={() => <ListGroup cateName={props.cateName}/>} />
                    <Route path={`/`} component={ListGroup} />
                </Switch>
            </NavSpy>
        </>
    )
}

const NavSpy = styled.div`
    min-height: 600px;
    &:after {
        display: block;
        content: '';
        clear: both
    }
`

export default ListField



// WEBPACK FOOTER //
// ./src/estimate_list/pages/tab/index.js